export function isSuperadminHost(hostname?: string): boolean {
  const host = (hostname || (typeof window !== 'undefined' ? window.location.hostname : '')).split(
    ':',
  )[0];
  return host === 'superadmin' || host.startsWith('superadmin.');
}

// Hosts that are allowed to open the CMS without a matching row in the
// tenants table (used to preview the dashboard on the dev server).
export function isDevBypassHost(hostname?: string): boolean {
  const host = (hostname || (typeof window !== 'undefined' ? window.location.hostname : '')).split(
    ':',
  )[0];
  return (
    host === 'dev.rezervator.ba' ||
    host === 'dev' ||
    host === 'localhost' ||
    host.endsWith('.localhost')
  );
}
